import React from 'react';
import { Container, TextContainer, IconContainer, CrossIconStyled } from './styles/IconCardStyled';
var IconCard = function IconCard(_ref) {
  var text = _ref.text,
    icon = _ref.icon,
    linkMessage = _ref.linkMessage,
    onClose = _ref.onClose,
    onLinkClick = _ref.onLinkClick;
  return React.createElement(Container, {
    onClick: onLinkClick
  }, icon, React.createElement(TextContainer, null, React.createElement("span", null, text), React.createElement("a", null, linkMessage)), onClose && React.createElement(IconContainer, null, React.createElement(CrossIconStyled, {
    onClick: function onClick(e) {
      e.stopPropagation();
      onClose();
    }
  })));
};
export default IconCard;